module.exports = __webpack_public_path__ + "img/tercero.2660782a.png";